import { render } from "./HFO_BG_FC_001.vue?vue&type=template&id=1bdc5bc9&scoped=true"
import script from "./HFO_BG_FC_001.vue?vue&type=script&lang=js"
export * from "./HFO_BG_FC_001.vue?vue&type=script&lang=js"

import "./HFO_BG_FC_001.vue?vue&type=style&index=0&id=1bdc5bc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdc5bc9"]])

export default __exports__